(() => {
  const removeArticleFieldNotes = () => {
    document
      .querySelectorAll('.tk9-reader-lab, .tk9-field-notes, .tk9-editorial-review-card')
      .forEach((node) => node.remove());
  };

  if (!document.getElementById('tk9-hide-article-field-notes')) {
    const style = document.createElement('style');
    style.id = 'tk9-hide-article-field-notes';
    style.textContent = '.tk9-reader-lab,.tk9-field-notes,.tk9-editorial-review-card{display:none!important;}';
    document.head.appendChild(style);
  }

  removeArticleFieldNotes();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeArticleFieldNotes, { once: true });
  }
  window.addEventListener('pageshow', removeArticleFieldNotes);
})();

const tk9UniqueHubArticles = [
  {
    title: 'The 90-Second Pre-Walk Reset',
    handle: 'calmer-first-minute-dog-walk-reset',
    url: '/blogs/team-k9-tips/calmer-first-minute-dog-walk-reset',
    image: 'https://cdn.shopify.com/s/files/1/2715/4364/t/70/assets/prewalk-reset-hero-desktop-20260623-v2.png?v=1782252778',
    tags: ['Dog Walking', 'Better Walks'],
    excerpt: 'Use a quick doorway reset, one release cue, and a cleaner first-minute setup before the leash gets tight.',
    date: 'Jun 23, 2026',
    datetime: '2026-06-23',
  },
  {
    title: "How To Help Your Dog Stay Calm Around Kids' Toys And Noise",
    handle: 'how-to-help-your-dog-stay-calm-around-kids-toys-and-noise',
    url: '/blogs/team-k9-tips/how-to-help-your-dog-stay-calm-around-kids-toys-and-noise',
    image: 'https://cdn.shopify.com/s/files/1/2715/4364/t/64/assets/dog-calm-around-kids-toys-1780697322890-01-wm.jpg?v=1780697324',
    tags: ['Kids And Dogs', 'Dog Behavior'],
    excerpt: "Use clear toy boundaries, calmer noise introductions, and a dog-only retreat zone to help your dog stay steadier when family-room chaos starts to build.",
    date: 'Jun 5, 2026',
    datetime: '2026-06-05',
  },
  {
    title: 'How To Keep A Senior Dog Mentally Stimulated',
    handle: 'how-to-keep-a-senior-dog-mentally-stimulated',
    url: '/blogs/team-k9-tips/how-to-keep-a-senior-dog-mentally-stimulated',
    image: 'https://cdn.shopify.com/s/files/1/2715/4364/t/64/assets/senior-dog-brain-games-1780543790837-01-wm.jpg?v=1780543791',
    tags: ['Senior Dogs', 'Enrichment'],
    excerpt: 'Use low-impact brain games, sniff walks, food enrichment, and short repeatable routines to keep your senior dog curious without overworking an older body.',
    date: 'Jun 3, 2026',
    datetime: '2026-06-03',
  },
  {
    title: 'Why Is My Dog Suddenly So Clingy?',
    handle: 'why-is-my-dog-suddenly-so-clingy',
    url: '/blogs/team-k9-tips/why-is-my-dog-suddenly-so-clingy',
    image: 'https://teamk9.com/cdn/shop/articles/clingy-dog-hero-wm-20260602.png?v=1780415763',
    tags: ['Dog Behavior', 'Newsletter'],
    excerpt: 'If your dog suddenly starts shadowing you, use this calm Team K9 clinginess check to look at discomfort, routine changes, stress carryover, and nearby independence.',
    date: 'Jun 2, 2026',
    datetime: '2026-06-02',
  },
  {
    title: 'Why Punishment Backfires in Dog Training (And What To Do Instead)',
    handle: 'why-punishment-backfires-in-dog-training',
    url: '/blogs/team-k9-tips/why-punishment-backfires-in-dog-training',
    image: 'https://cdn.shopify.com/s/files/1/2715/4364/t/57/assets/punishment-backfires-hero-wm-20260531.jpg?v=1780214333',
    tags: ['Dog Training', 'Behavior & Calm'],
    excerpt: 'Punishment can stop behavior in the moment while making the real problem worse. Use structure, distance, and rewards to teach the next right choice.',
    date: 'May 31, 2026',
    datetime: '2026-05-31',
  },
  {
    title: "Why Dogs Bring You Their Favorite Toy When You're Sad",
    handle: 'when-your-dog-brings-you-the-best-thing-they-own',
    url: '/blogs/team-k9-tips/when-your-dog-brings-you-the-best-thing-they-own',
    image: 'https://cdn.shopify.com/s/files/1/2715/4364/t/57/assets/favorite-toy-comfort-hero-wm-20260528.jpg?v=1779951927',
    tags: ['Dog Comfort', 'Behavior & Calm'],
    excerpt: 'Sometimes a dog does not know the words for comfort. So they bring the thing that makes their own world better, place it near you, and stay.',
    date: 'May 28, 2026',
    datetime: '2026-05-28',
  },
  {
    title: 'How To Stress Check Your Dog Before Behavior Escalates',
    handle: 'how-to-stress-check-your-dog',
    url: '/blogs/team-k9-tips/how-to-stress-check-your-dog',
    image: 'https://cdn.shopify.com/s/files/1/2715/4364/t/46/assets/stress-check-your-dog-2026-05-21-1779413697687-01.png?v=1779413699',
    tags: ['Dog Body Language', 'Newsletter'],
    excerpt: 'Use this 3-second dog stress check to spot quiet stress signals, read body tension, respect avoidance, and prevent bigger reactions.',
    date: 'May 21, 2026',
    datetime: '2026-05-21',
  },
  {
    title: 'What To Do After Your Dog Walks',
    handle: 'what-to-do-after-your-dog-walks',
    url: '/blogs/team-k9-tips/what-to-do-after-your-dog-walks',
    image: 'https://cdn.shopify.com/s/files/1/2715/4364/t/46/assets/post-walk-decompression-2026-05-20-1779337414963-01.png?v=1779337417',
    tags: ['Dog Walking', 'Newsletter'],
    excerpt: 'If your dog comes home wired after walks, use this 15-minute post-walk reset to help them decompress, settle, and recover from outdoor stimulation.',
    date: 'May 21, 2026',
    datetime: '2026-05-21',
  },
  {
    title: 'How To Calm An Overstimulated Dog Inside The House',
    handle: 'how-to-calm-an-overstimulated-dog-inside-the-house',
    url: '/blogs/team-k9-tips/how-to-calm-an-overstimulated-dog-inside-the-house',
    image: 'https://cdn.shopify.com/s/files/1/2715/4364/t/46/assets/indoor-overstimulation-reset-hero-1779321583626-01.png?v=1779321584',
    tags: ['Dog Behavior', 'Newsletter'],
    excerpt: 'If your dog suddenly gets wild inside, they may be overstimulated instead of misbehaving. Use this indoor calm reset to lower input, add a simple job, and guide real rest.',
    date: 'May 20, 2026',
    datetime: '2026-05-20',
  },
  {
    title: 'What To Do When Weather Changes Affect Your Dog',
    handle: 'what-to-do-when-weather-changes-affect-your-dog',
    url: '/blogs/team-k9-tips/what-to-do-when-weather-changes-affect-your-dog',
    image: 'https://cdn.shopify.com/s/files/1/2715/4364/t/46/assets/blog-hub-weather-changes-dog-20260522-1779472315803-01.png?v=1779472317',
    tags: ['Seasonal Routine', 'Dog Behavior'],
    excerpt: 'When the weather changes, your dog’s routine changes too. Use this seasonal reset to adjust walks, triggers, enrichment, and calmer daily structure.',
    date: 'May 19, 2026',
    datetime: '2026-05-19',
  },
  {
    title: 'The Dog Car Setup That Keeps Your Back Seat Cleaner',
    handle: 'dog-car-setup-that-keeps-your-back-seat-cleaner',
    url: '/blogs/team-k9-tips/dog-car-setup-that-keeps-your-back-seat-cleaner',
    image: 'https://cdn.shopify.com/s/files/1/2715/4364/t/46/assets/k9-blog-car-cover-fresh-lifestyle-approved-v1.png?v=1779229017',
    tags: ['Car Seat Cover', 'Dog Car Hammock'],
    excerpt: 'A cleaner back seat starts before your dog jumps in. Build a waterproof, supported, easier-to-clean dog car setup with Team K9.',
    date: 'May 18, 2026',
    datetime: '2026-05-18',
  },
  {
    title: 'What To Do Before Every Dog Walk If Your Dog Pulls',
    handle: 'what-to-do-before-every-dog-walk-if-your-dog-pulls',
    url: '/blogs/team-k9-tips/what-to-do-before-every-dog-walk-if-your-dog-pulls',
    image: 'https://cdn.shopify.com/s/files/1/2715/4364/t/46/assets/blog-hub-pre-walk-pulling-reset-20260522-1779472341321-01.png?v=1779472342',
    tags: ['Dog Harness', 'Dog Training'],
    excerpt: 'A calmer walk usually starts before the door opens. Use this pre-walk reset to lower excitement, catch warning signs, and give your dog clearer boundaries.',
    date: 'May 18, 2026',
    datetime: '2026-05-18',
  },
  {
    title: 'Why Treats Stop Working Outside With Your Dog',
    handle: 'why-treats-stop-working-outside-with-your-dog',
    url: '/blogs/team-k9-tips/why-treats-stop-working-outside-with-your-dog',
    image: 'https://cdn.shopify.com/s/files/1/2715/4364/t/46/assets/k9-blog-treat-test-product-neutral-v1.png?v=1779215908',
    tags: ['Team K9 Tips', 'Dog Training'],
    excerpt: 'If your dog takes treats inside but ignores them outside, use this simple treat test to find where the environment gets too hard for focus.',
    date: 'May 18, 2026',
    datetime: '2026-05-18',
  },
  {
    title: '5 Simple Ways to Stop Dog Leash Pulling',
    handle: 'prevent-leash-pulling',
    url: '/blogs/team-k9-tips/prevent-leash-pulling',
    image: 'https://cdn.shopify.com/s/files/1/2715/4364/t/46/assets/blog-hub-prevent-leash-pulling-20260522-1779471351133-01.png?v=1779471353',
    tags: ['Dog Walking', 'Dog Training'],
    excerpt: 'Use simple leash-pulling fixes, better timing, and the right walking setup to make everyday walks calmer.',
    date: 'Jul 10, 2023',
    datetime: '2023-07-10',
  },
  {
    title: 'Ultimate Guide: Choosing the Right Dog Harness in 5 Steps',
    handle: 'choosing-the-right-dog-harness',
    url: '/blogs/team-k9-tips/choosing-the-right-dog-harness',
    image: 'https://cdn.shopify.com/s/files/1/2715/4364/t/46/assets/blog-hub-choosing-dog-harness-20260522-1779471375270-01.png?v=1779471376',
    tags: ['Dog Harness', 'Buying Guide'],
    excerpt: 'Choose a dog harness by matching fit, control points, pulling behavior, hardware, comfort, and your walking routine.',
    date: 'Feb 14, 2024',
    datetime: '2024-02-14',
  },
  {
    title: "Understanding Your Dog's Body Language",
    handle: 'canine-body-language',
    url: '/blogs/team-k9-tips/canine-body-language',
    image: 'https://cdn.shopify.com/s/files/1/2715/4364/t/46/assets/blog-hub-canine-body-language-20260522-1779471399548-01.png?v=1779471401',
    tags: ['Dog Body Language', 'Dog Behavior'],
    excerpt: 'Read the whole dog, spot early stress signals, and respond before body language turns into bigger reactions.',
    date: 'Feb 19, 2024',
    datetime: '2024-02-19',
  },
  {
    title: 'How To Master Dog Harness Training',
    handle: 'dog-harness-training',
    url: '/blogs/team-k9-tips/dog-harness-training',
    image: 'https://cdn.shopify.com/s/files/1/2715/4364/t/46/assets/blog-hub-dog-harness-training-20260522-1779471421950-01.png?v=1779471423',
    tags: ['Dog Harness', 'Dog Training'],
    excerpt: 'Introduce a harness calmly, build a predictable walk routine, and make the first week of harness training easier.',
    date: 'Feb 28, 2024',
    datetime: '2024-02-28',
  },
  {
    title: 'How to Manage Dog Shedding',
    handle: 'how-to-manage-dog-shedding',
    url: '/blogs/team-k9-tips/how-to-manage-dog-shedding',
    image: 'https://cdn.shopify.com/s/files/1/2715/4364/t/46/assets/blog-hub-dog-shedding-20260522-1779471447263-01.png?v=1779471448',
    tags: ['Dog Shedding', 'Cleaner Home'],
    excerpt: 'Manage shedding with a simple home routine: brush, catch hair early, protect furniture, and reset cleanup zones.',
    date: 'Mar 10, 2024',
    datetime: '2024-03-10',
  },
  {
    title: 'What To Do Before Saying No To Your Dog',
    handle: 'what-to-do-before-saying-no-to-your-dog',
    url: '/blogs/team-k9-tips/what-to-do-before-saying-no-to-your-dog',
    image: 'https://cdn.shopify.com/s/files/1/2715/4364/t/46/assets/blog-hub-before-saying-no-20260522-1779471472021-01.png?v=1779471473',
    tags: ['Dog Behavior', 'Boundaries'],
    excerpt: 'Before correcting your dog, change the setup, lower pressure, and give a clearer job so boundaries feel teachable.',
    date: 'May 20, 2026',
    datetime: '2026-05-20',
  },
];

const tk9Escape = (value) =>
  String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

const tk9ArticleCard = (article, index) => `
  <article class="tk9-blog-hub__card" data-page="1">
    <a class="tk9-blog-hub__card-image" href="${article.url}" data-el="003bloghub-20260522-card-image-${article.handle}" aria-label="Read ${tk9Escape(article.title)}">
      <img src="${article.image}" alt="${tk9Escape(article.title)}" loading="${index < 3 ? 'eager' : 'lazy'}">
    </a>
    <div class="tk9-blog-hub__card-body">
      <div class="tk9-blog-hub__card-tags">
        ${article.tags.map((tag) => `<span>${tk9Escape(tag)}</span>`).join('')}
      </div>
      <h3><a href="${article.url}" data-el="003bloghub-20260522-card-title-${article.handle}">${tk9Escape(article.title)}</a></h3>
      <p>${tk9Escape(article.excerpt)}</p>
      <div class="tk9-blog-hub__card-footer">
        <time datetime="${article.datetime}">${article.date}</time>
        <a href="${article.url}" data-el="003bloghub-20260522-card-read-${article.handle}">Read</a>
      </div>
    </div>
  </article>`;

function tk9RenderUniqueHubCards() {
  if (window.location.pathname !== '/blogs/team-k9-tips') return;

  const grid = document.querySelector('.tk9-blog-hub__grid');
  if (!grid) return;

  grid.innerHTML = tk9UniqueHubArticles.map(tk9ArticleCard).join('');
  grid.setAttribute('data-tk9-unique-card-images', '20260623-prewalk-reset');

  document.querySelectorAll('a[href*="do-this-after-your-dog-walks"]').forEach((link) => {
    link.href = link.href.replace('do-this-after-your-dog-walks', 'what-to-do-after-your-dog-walks');
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    tk9RenderUniqueHubCards();
    window.setTimeout(tk9RenderUniqueHubCards, 900);
    window.setTimeout(tk9RenderUniqueHubCards, 2400);
  }, { once: true });
} else {
  tk9RenderUniqueHubCards();
  window.setTimeout(tk9RenderUniqueHubCards, 900);
  window.setTimeout(tk9RenderUniqueHubCards, 2400);
}

// prewalk-reset-hub-card-20260623
